module.exports = __webpack_public_path__ + "static/media/f4.623d76f8.jpg";